import human from './default'

export default {
    human
}
